// PNL Project registry — import markdown from src, media files from public folder
// Images and videos are in /public/projects/pnl/

import pnlMd from './index.md'

// Cover images
const coverLight = '/projects/pnl/pnl-cover-v3.webp'
const coverDark = '/projects/pnl/cover-dark.jpg'

// Trading Hub
const tradingHubLight = '/projects/pnl/trading-hub-light.jpg'
const tradingHubDark = '/projects/pnl/trading-hub-dark.jpg'
const tradingHubActiveLight = '/projects/pnl/trading-hub-active-light.jpg'

// Trade Details
const tradeDetailsLight = '/projects/pnl/trade-details-light.jpg'
const tradeDetailsEditLight = '/projects/pnl/trade-details-edit-light.jpg'

// Stats & Analytics
const statsOverviewLight = '/projects/pnl/stats-overview-light.jpg'

// Recent Trades
const recentTradesLight = '/projects/pnl/recent-trades-light.jpg'
const recentTradesDark = '/projects/pnl/recent-trades-dark.jpg'

// Login
const loginLight = '/projects/pnl/login-light.jpg'
const loginDark = '/projects/pnl/login-dark.jpg'

// Journal
const journalLight = '/projects/pnl/journal-light.jpg'
const journalDark = '/projects/pnl/journal-dark.jpg'

// Discipline Mode
const disciplineModeActiveDark = '/projects/pnl/discipline-mode-active-dark.jpg'
const disciplineModeModalLight = '/projects/pnl/discipline-mode-modal-light.jpg'
const disciplineModeTimerDark = '/projects/pnl/discipline-mode-timer-dark.jpg'

// Chat & Community
const chatRoomsLight = '/projects/pnl/chat-rooms-light.jpg'

// Auto Journal
const autoJournalLight = '/projects/pnl/auto-journal-light.jpg'
const autoJournalDark = '/projects/pnl/auto-journal-dark.jpg'

// Add Trade Modal
const addTradeModalLight = '/projects/pnl/add-trade-modal-light.jpg'

// App Blocker
const appBlockerDark = '/projects/pnl/app-blocker-dark.jpg'

// Video
const demoVideo = 'https://drive.google.com/file/d/118LcfskFMK-l74W00-ryjz2nT1G8Tn-X/view?usp=sharing'

const pnlImages = {
  './cover-light.jpg': coverLight,
  './cover-dark.jpg': coverDark,
  './trading-hub-light.jpg': tradingHubLight,
  './trading-hub-dark.jpg': tradingHubDark,
  './trading-hub-active-light.jpg': tradingHubActiveLight,
  './trade-details-light.jpg': tradeDetailsLight,
  './trade-details-edit-light.jpg': tradeDetailsEditLight,
  './stats-overview-light.jpg': statsOverviewLight,
  './recent-trades-light.jpg': recentTradesLight,
  './recent-trades-dark.jpg': recentTradesDark,
  './login-light.jpg': loginLight,
  './login-dark.jpg': loginDark,
  './journal-light.jpg': journalLight,
  './journal-dark.jpg': journalDark,
  './discipline-mode-active-dark.jpg': disciplineModeActiveDark,
  './discipline-mode-modal-light.jpg': disciplineModeModalLight,
  './discipline-mode-timer-dark.jpg': disciplineModeTimerDark,
  './chat-rooms-light.jpg': chatRoomsLight,
  './auto-journal-light.jpg': autoJournalLight,
  './auto-journal-dark.jpg': autoJournalDark,
  './add-trade-modal-light.jpg': addTradeModalLight,
  './app-blocker-dark.jpg': appBlockerDark,
}

const pnlVideos = {
  './XRecorderLite_05032026_200257.mp4': demoVideo,
}

const pnlProject = {
  markdownUrl: pnlMd,
  images: pnlImages,
  videos: pnlVideos,
  // Curated ordered screenshot list for the detail page carousel
  screenshots: [
    { src: coverLight, caption: 'P&L App — Cover' },
    { src: tradingHubLight, caption: 'Trading Hub — Character & Tier System' },
    { src: tradingHubActiveLight, caption: 'Trading Hub — Discipline Mode Active' },
    { src: tradeDetailsLight, caption: 'Trade Details View' },
    { src: tradeDetailsEditLight, caption: 'Edit Trade Modal' },
    { src: statsOverviewLight, caption: 'Performance Analytics Overview' },
    { src: recentTradesLight, caption: 'Recent Trades Feed' },
    { src: journalLight, caption: 'Trading Journal Calendar' },
    { src: autoJournalLight, caption: 'Auto-Journal — Broker Sync' },
    { src: addTradeModalLight, caption: 'Add Trade Modal' },
    { src: chatRoomsLight, caption: 'Community Chat Rooms' },
    { src: disciplineModeModalLight, caption: 'Discipline Mode Settings' },
  ],
  slug: 'pnl-app',
  title: 'P&L App - Trading Discipline & Performance Platform',
  subtitle: 'Full-Stack Team Lead | October 2025 - January 2026',
  date: '2026-01-31',
  tags: ['React Native', 'Node.js', 'Kotlin', 'Full-Stack', 'Mobile App', 'AI Integration'],
  description: 'A neuroscience-based trading journal and discipline platform with AI-powered insights, auto-journal sync with 20+ brokerages, and innovative Discipline Mode using Android Accessibility APIs.',
  author: 'Aqib',
  readTime: '20 min read',
  thumbnail: coverLight,
  coverLight: coverLight,
  coverDark: coverDark,
  demoVideo: demoVideo,
  appStoreLink: 'https://apps.apple.com/ie/app/pnl-app/id6756570340',
  playStoreLink: 'https://play.google.com/store/apps/details?id=co.pnlapp',
  websiteLink: 'https://pnlapp.co',
}

export default pnlProject
